// ===== Supabase + end-to-end encryption =====
// The publishable key is safe to ship: tables are locked by RLS and,
// more importantly, every value is AES-GCM encrypted in the browser
// with a passphrase that never leaves the device. The server only
// ever stores ciphertext.
export const SUPABASE_URL = 'https://ehduuyfbfwzemblboiiq.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_TWqc29oFQ-2l1-FTBt1Ptw__lzsIMPd';

// Bumped manually on notable releases; shown at the bottom of the app so both
// phones can confirm they're running the same build. Keep CHANGELOG below in
// sync — a mismatch between the two is what triggers the "What's New" popup.
export const APP_VERSION = '1.11';

// The commit this build was made from (short hash), stamped by build.mjs from
// Cloudflare's CF_PAGES_COMMIT_SHA; 'local' for a build made elsewhere. Shown
// off-production, so the footer proves the phone picked up the latest deploy
// rather than a stale cached copy — nobody has to bump anything by hand.
// Metadata only: APP_VERSION holds the version being prepared and the CHANGELOG
// stays keyed to it, so a run of betas folds into that plain version on release.
const BUILD_ID = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'local';

// Which deployment you're looking at, derived from the hostname rather than
// hand-set, so a beta build can never be labelled as production.
// Production shows the bare version; everything else shows the build marker.
//
// Production is matched exactly rather than used as the fallback: Cloudflare
// also serves every deployment on a <hash>.medcalc-ds5.pages.dev preview URL,
// and those were being labelled production — precisely backwards for a marker
// whose job is "am I looking at the real app?".
const PRODUCTION_HOST = 'medcalc-ds5.pages.dev';
export const CHANNEL =
  ['localhost', '127.0.0.1'].includes(location.hostname) ? 'dev'
  : location.hostname === PRODUCTION_HOST ? 'production'
  : 'beta';
export const VERSION_LABEL =
  CHANNEL === 'dev' ? `v${APP_VERSION} - dev`
  : CHANNEL === 'beta' ? `v${APP_VERSION} - beta (${BUILD_ID})`
  : `v${APP_VERSION}`;

// Lets a developer view the authenticated screens without real credentials.
// Only ever true on localhost/127.0.0.1 — never on the deployed site —
// so it can't accidentally expose a bypass to real users. In this mode the app
// skips AuthGate/Supabase entirely and runs on the in-memory MOCK_DATA below;
// see the root render call and MedicationApp's data-loading effect and save
// handlers, which all check this flag before touching the network.
export const DEV_MODE = typeof location !== 'undefined' && ['localhost', '127.0.0.1'].includes(location.hostname);
